import { render, staticRenderFns } from "./CarouselSliderMobile.vue?vue&type=template&id=6984d6ee&"
import script from "./CarouselSliderMobile.vue?vue&type=script&lang=js&"
export * from "./CarouselSliderMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports